import { component } from "picoapp";
import choozy from "choozy";
import { add, remove, on, qs, qsa, toggle } from "@selfaware/martha";
import EmblaCarousel from "embla-carousel";

export default component((node, ctx) => {
  let {
    carousel,
    next,
    prev,
    counter,
    activeIndex,
    video,
    videoContainer,
    openVideo,
    closeVideo,
    toggleTranscript,
    transcript,
  } = choozy(node);

  let isHow = qs("main.how-to");

  if (isHow) {
    let allSlides = qsa(".slides[data-product]");

    allSlides.forEach((slide, index) => {
      if (index != 0) {
        add(slide, "hidden");
      } else {
        if (node.dataset.product == slide.dataset.product) {
          let first = slide.parentElement;

          let buttonContainer = document.createElement("div");
          add(buttonContainer, "slides-btn-container");

          first.parentElement.insertBefore(buttonContainer, first);

          allSlides.forEach((el, index) => {
            let btn = document.createElement("button");
            btn.innerHTML = el.dataset.product;
            add(btn, "btn");
            btn.dataset.product = el.dataset.product;
            btn.style.setProperty("--primary", el.dataset.theme);

            if (index == 0) add(btn, "is-active");
            buttonContainer.append(btn);

            on(btn, "click", (e) => {
              allSlides.forEach((slide, key) => {
                qsa(
                  `.btn:not([data-product="${e.target.dataset.product}"])`
                ).forEach((btn) => remove(btn, "is-active"));
                add(e.target, "is-active");

                if (slide.dataset.product == e.target.dataset.product) {
                  remove(slide, "hidden");
                  add(e.target, "is-active");
                } else {
                  add(slide, "hidden");
                }
              });
            });
          });
        }
      }
    });
  }

  if (node.dataset.config != "list" || document.documentElement.clientWidth < 950) {
    const embla = EmblaCarousel(carousel, {
      loop: false,
      skipSnaps: false,
      trimSnaps: true,
      containScroll: true,
      align: "start",
    });

    if (next) {
      on(prev, "click", () => embla.scrollPrev());
      on(next, "click", () => embla.scrollNext());
    }

    if (counter) {
      on(counter, "click", (e) => {
        embla.scrollTo(e.target.dataset.index);
      });
    }

    embla.on("select", () => {
      if (counter) {
        remove(counter, "is-active");
        add(
          qs(`.js-counter[data-index="${embla.selectedScrollSnap()}"]`, node),
          "is-active"
        );
      }

      if (activeIndex) {
        activeIndex.innerHTML = embla.selectedScrollSnap() + 1;
      }
    });
  }

  if (openVideo) {
    on(openVideo, "click", () => {
      remove(videoContainer, "hidden");
    });

    on(closeVideo, "click", () => {
      add(videoContainer, "hidden");
    });

    on(toggleTranscript, "click", () => {
      toggle(video, "hidden");
      toggle(transcript, "hidden");
    });
  }
});
